import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'tsyringe';
import { placeholders } from '@gn-audio/core/common/helpers';
import { BasketEventBus } from '../../services/basket-event-bus.service';
import { getBasketTotalCount } from '../../utilities/get-basket-total-count';
import './basket-total.component.scss';
import template from './basket-total.component.html';
var BasketTotalComponent = /** @class */ (function () {
    function BasketTotalComponent(eventBus, translations) {
        var _this = this;
        this.eventBus = eventBus;
        this.translations = translations;
        this.reactOnStoreChanges = function (state) {
            var totalCount = getBasketTotalCount(state);
            var areProductsInBasket = totalCount > 0;
            _this.element.innerHTML = areProductsInBasket
                ? placeholders(template, state, _this.translations)
                : '';
            if (areProductsInBasket) {
                var subTotalElement = _this.element.querySelector('.basket-total__sub-total');
                var orderDiscountSection = _this.element.querySelector('.basket-total__section--discount');
                var c_product_before_discount_formatted = state.c_product_before_discount_formatted, c_product_sub_total_formatted = state.c_product_sub_total_formatted, c_product_total_formatted = state.c_product_total_formatted, _a = state.order_price_adjustments, order_price_adjustments = _a === void 0 ? [] : _a;
                var strikethroughTotalFormatted = void 0;
                if (order_price_adjustments.length > 0) {
                    strikethroughTotalFormatted = c_product_sub_total_formatted;
                    subTotalElement.innerHTML = c_product_sub_total_formatted;
                    orderDiscountSection.classList.add("visible" /* CssClass.Visible */);
                }
                else {
                    strikethroughTotalFormatted = c_product_before_discount_formatted;
                    subTotalElement.innerHTML = c_product_before_discount_formatted;
                    orderDiscountSection.classList.remove("visible" /* CssClass.Visible */);
                }
                if (strikethroughTotalFormatted !== c_product_total_formatted) {
                    subTotalElement.classList.add("visible" /* CssClass.Visible */);
                }
                else {
                    subTotalElement.classList.remove("visible" /* CssClass.Visible */);
                }
            }
        };
    }
    BasketTotalComponent.prototype.register = function (state) {
        this.attachEvents();
        this.attachToTargetElement();
        this.reactOnStoreChanges(state);
    };
    BasketTotalComponent.prototype.attachEvents = function () {
        this.eventBus.subscribe("basket-updated" /* BasketEvent.BasketUpdated */, this.reactOnStoreChanges);
    };
    BasketTotalComponent.prototype.attachToTargetElement = function () {
        var targetElement = document.querySelector(".basket-ui__footer" /* BasketUIElementSelector.BasketFooter */);
        if (!targetElement) {
            console.warn("Basket sub total was not able to attach to target element: ".concat(".basket-ui__footer" /* BasketUIElementSelector.BasketFooter */));
            return;
        }
        this.element = document.createElement('div');
        this.element.classList.add('basket-total');
        targetElement.appendChild(this.element);
    };
    BasketTotalComponent = __decorate([
        injectable(),
        __param(1, inject("basketTranslations" /* DiToken.Translations */)),
        __metadata("design:paramtypes", [BasketEventBus, Object])
    ], BasketTotalComponent);
    return BasketTotalComponent;
}());
export { BasketTotalComponent };
